module.exports = __webpack_public_path__ + "img/Sandrine-Azhar.7c6a2f2e.png";